import React, { memo, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import { Card, Col, Row } from "react-bootstrap";
import CardHeader from "./CardHeader";
import CardBody from "./CardBody";
import CardBodyWithMap from "./CardBodyWithMap";
import { roundOfAcres, Unit } from "../../../helpers/unit";

const FieldDetails = memo(({ shapeRefId, isCompleted, shapeDetails, tareLoadHistory, harvestSummaryList }) => {
  const [showDropdown, setShowDropdown] = useState(false);
  const isEnableHarvestProjection = useSelector((state) => state.farm.currentFarm.is_harvest_projection_enable);
  const settings = useSelector((state) => state.user.settings);
  const fieldListById = useSelector((state) => state.dashboard.field.fieldListById.payload);
  const [cardMapId, setCardMapId] = useState([])

  const unit = useMemo(() => Unit.getInstance(), []);
  let harvestList = harvestSummaryList && harvestSummaryList.hasOwnProperty(fieldListById[shapeRefId].regionDetails.geo_region_uuid) ? harvestSummaryList[fieldListById[shapeRefId].regionDetails.geo_region_uuid] : null;

  const getHarvestValue = (key) => {
    let harvestSummary = harvestList && harvestList.hasOwnProperty("summary") ? harvestList.summary : null;
    if (!harvestSummary) return 0;
    return harvestList.summary[key] ? harvestList.summary[key] : 0;
  };

  return (
    <Card className="field-item lboard-filed-items fadeInLeft">
      <Card.Header className={`field-item-header ${!showDropdown && "open"}`}>
        <div className="m-0 h-100 d-flex">
          <div className="btn-grp d-flex">
            <Col className="dropdown-toggle-btn" onClick={() => setShowDropdown(!showDropdown)}>
              {showDropdown ? <i className="fa fa-chevron-down" aria-hidden="true"></i> : <i className="fa fa-chevron-right" aria-hidden="true"></i>}
            </Col>
            {/* <Col className="drag-button">
                    <i className="fa fa-th" aria-hidden="true"></i>
                </Col> */}
          </div>

          <div className="field-details d-flex">
            <div className="field-info">
              <Row className="field-name" title={shapeDetails.geo_shape_name}>
                <span>{shapeDetails.geo_shape_name}</span>
              </Row>
              {/* <Row className="field-type">Field
                <span style={{ color: workTypeColor, borderColor: workTypeColor }}>{workTypesById[workTypeId].work_type}</span>
            </Row> */}
            </div>
            <div className="load-info">
              <Row className="value">{isEnableHarvestProjection ? unit.toArea(getHarvestValue("total_acreage"), 0) : roundOfAcres(shapeDetails.regionDetails.totalAcres)}</Row>
              <Row className="label">{`Total ${settings.areaShortName}`}</Row>
              {/* {workTypeId === 2 && <>
                <Row className="value">{loadDetails.isRequesting ? <LoadingStyle /> : loadDetails.loads}</Row>
                <Row className="label">Total Loads</Row>
            </>} */}
            </div>
            {<CardHeader shapeRefId={shapeRefId} />}
          </div>
        </div>
      </Card.Header>
      {showDropdown ? <>{isEnableHarvestProjection ? <CardBodyWithMap cardMapId={cardMapId} setCardMapId={setCardMapId} showDropdown={showDropdown} shapeRefId={shapeRefId} isCompleted={isCompleted} /> : <CardBody showDropdown={showDropdown} shapeRefId={shapeRefId} isCompleted={isCompleted} />}</> : <></>}
    </Card>
  );
});

export default FieldDetails;
